module.exports = __webpack_public_path__ + "img/18-could-citys-health.fd8ab6dd.png";